<template>
  <div v-loading="loading" class="month-task">
    <div class="header">
      <div class="pre">
        <el-button type="text" @click="goPreMonth">上月</el-button>
      </div>
      <div class="title">
        {{ curMonth }}销售任务
      </div>
      <div v-if="!isEnd" class="next">
        <el-button type="text" @click="goNextMonth">下月</el-button>
      </div>
    </div>
    <div class="context">
      <table>
        <colgroup>
          <col style="width: 60px;" />
        </colgroup>
        <colgroup>
          <col style="width: 80px;" />
          <col style="width: auto;" />
        </colgroup>
        <colgroup>
          <col style="width: 80px;" />
          <col style="width: auto;" />
        </colgroup>
        <colgroup>
          <col style="width: 90px;" />
          <col style="width: auto;" />
        </colgroup>
        <colgroup>
          <col style="width: 90px;" />
          <col style="width: auto;" />
        </colgroup>
        <colgroup>
          <col style="width: 90px;" />
          <col style="width: auto;" />
        </colgroup>
        <colgroup>
          <col style="width: 90px;" />
          <col style="width: auto;" />
        </colgroup>
        <tr class="table-header">
          <td :rowspan="2">区域</td>
          <td :colspan="2">活跃客户</td>
          <td :colspan="2">订单客户</td>
          <td :colspan="2">订单笔数</td>
          <td :colspan="2">急件销售额</td>
          <td :colspan="2">批量销售额</td>
          <td :colspan="2">机油销售额</td>
        </tr>
        <tr class="table-header" data-uac="dashboard.settask$$工作台.设置销售任务">
          <td width="100px">{{ showMonthStr }}目标</td>
          <td>达成率</td>
          <td width="100px">{{ showMonthStr }}目标</td>
          <td>达成率</td>
          <td width="100px">{{ showMonthStr }}目标</td>
          <td>达成率</td>
          <td width="100px">{{ showMonthStr }}目标</td>
          <td>达成率</td>
          <td width="100px">{{ showMonthStr }}目标</td>
          <td>达成率</td>
          <td width="100px">{{ showMonthStr }}目标</td>
          <td>达成率</td>
        </tr>
        <template v-if="monthData && monthData.length">
          <tr v-for="areaData in monthData" :key="monthNow + '.' + areaData.area">
            <td>{{ areaData.area }}</td>
            <!--活跃客户数-->
            <td>
              <span v-if="areaData.epcActive">{{ areaData.epcActive }}</span>
              <span v-else>未设置</span><el-button type="text" @click="configMonthTask" v-uac="'dashboard.settask'"><i class="crm-icon-edit" /></el-button>
            </td>
            <td>
              <div v-if="areaData.epcActive">{{ areaData.epcActiveResult / areaData.epcActive | percentFmt }}</div>
              <div :class="{ percent: areaData.epcActive }">({{ areaData.epcActiveResult }})</div>
            </td>
            <!--下单客户数-->
            <td>
              <span v-if="areaData.buyerCount">{{ areaData.buyerCount }}</span>
              <span v-else>未设置</span><el-button type="text" @click="configMonthTask" v-uac="'dashboard.settask'"><i class="crm-icon-edit" /></el-button>
            </td>
            <td>
              <div v-if="areaData.buyerCount">{{ areaData.buyerCountResult / areaData.buyerCount | percentFmt }}</div>
              <div :class="{ percent: areaData.buyerCount }">({{ areaData.buyerCountResult }})</div>
            </td>
            <!--订笔数-->
            <td>
              <span v-if="areaData.orderCount">{{ areaData.orderCount }}</span>
              <span v-else>未设置</span><el-button type="text" @click="configMonthTask" v-uac="'dashboard.settask'"><i class="crm-icon-edit" /></el-button>
            </td>
            <td>
              <div v-if="areaData.orderCount">{{ areaData.orderCountResult / areaData.orderCount | percentFmt }}</div>
              <div :class="{ percent: areaData.buyerCount }">({{ areaData.orderCountResult }})</div>
            </td>
            <!--急件销售额-->
            <td>
              <span v-if="areaData.fastAmount">{{ areaData.fastAmount | wanFmt }}</span>
              <span v-else>未设置</span><el-button type="text" @click="configMonthTask" v-uac="'dashboard.settask'"><i class="crm-icon-edit" /></el-button>
            </td>
            <td>
              <div v-if="areaData.fastAmount">{{ areaData.fastAmountResult / areaData.fastAmount | percentFmt }}</div>
              <div :class="{ percent: areaData.buyerCount }">({{ areaData.fastAmountResult | wanFmt }})</div>
            </td>
            <!--批单销售额-->
            <td>
              <span v-if="areaData.batchAmount">{{ areaData.batchAmount | wanFmt }}</span>
              <span v-else>未设置</span><el-button type="text" @click="configMonthTask" v-uac="'dashboard.settask'"><i class="crm-icon-edit" /></el-button>
            </td>
            <td>
              <div v-if="areaData.batchAmount">{{ areaData.batchAmountResult / areaData.batchAmount | percentFmt }}</div>
              <div :class="{ percent: areaData.buyerCount }">({{ areaData.batchAmountResult | wanFmt }})</div>
            </td>
            <!--机油销售额-->
            <td>
              <span v-if="areaData.oilAmount">{{ areaData.oilAmount | wanFmt }}</span>
              <span v-else>未设置</span><el-button type="text" @click="configMonthTask" v-uac="'dashboard.settask'"><i class="crm-icon-edit" /></el-button>
            </td>
            <td>
              <div v-if="areaData.oilAmount">{{ areaData.oilAmountResult / areaData.oilAmount | percentFmt }})</div>
              <div :class="{ percent: areaData.buyerCount }">({{ areaData.oilAmountResult | wanFmt }})</div>
            </td>
          </tr>
          <tr v-if="monthData.length > 1">
            <td>合计</td>
            <!--活跃客户数-->
            <td>
              <span v-if="totalEpcActive">{{ totalEpcActive }}</span>
              <span v-else>--</span>
            </td>
            <td>
              <div v-if="totalEpcActive">{{ monthData.reduce((p, c) => p + c.epcActiveResult, 0) / totalEpcActive | percentFmt }}</div>
              <div :class="{ percent: totalEpcActive }">({{ monthData.reduce((p, c) => p + c.epcActiveResult, 0) }})</div>
            </td>
            <!--下单客户数-->
            <td>
              <span v-if="totalBuyerCount">{{ totalBuyerCount }}</span>
              <span v-else>--</span>
            </td>
            <td>
              <div v-if="totalBuyerCount">{{ monthData.reduce((p, c) => p + c.buyerCountResult, 0) / totalBuyerCount | percentFmt }}</div>
              <div :class="{ percent: totalBuyerCount }">({{ monthData.reduce((p, c) => p + c.buyerCountResult, 0) }})</div>
            </td>
            <!--订笔数-->
            <td>
              <span v-if="totalOrderCount">{{ totalOrderCount }}</span>
              <span v-else>--</span>
            </td>
            <td>
              <div v-if="totalOrderCount">{{ monthData.reduce((p, c) => p + c.orderCountResult, 0) / totalOrderCount | percentFmt }}</div>
              <div :class="{ percent: totalOrderCount }">({{ monthData.reduce((p, c) => p + c.orderCountResult, 0) }})</div>
            </td>
            <!--急件销售额-->
            <td>
              <span v-if="totalFastAmount">{{ totalFastAmount | wanFmt }}</span>
              <span v-else>--</span>
            </td>
            <td>
              <div v-if="totalFastAmount">{{ monthData.reduce((p, c) => p + c.fastAmountResult, 0) / totalFastAmount | percentFmt }}</div>
              <div :class="{ percent: totalFastAmount }">({{ +monthData.reduce((p, c) => p + c.fastAmountResult, 0).toFixed(2) | wanFmt }})</div>
            </td>
            <!--批单销售额-->
            <td>
              <span v-if="totalBatchAmount">{{ totalBatchAmount | wanFmt }}</span>
              <span v-else>--</span>
            </td>
            <td>
              <div v-if="totalBatchAmount">{{ monthData.reduce((p, c) => p + c.batchAmountResult, 0) / totalBatchAmount | percentFmt }}</div>
              <div :class="{ percent: totalBatchAmount }">({{ +monthData.reduce((p, c) => p + c.batchAmountResult, 0).toFixed(2) | wanFmt }})</div>
            </td>
            <!--机油销售额-->
            <td>
              <span v-if="totalOilAmount">{{ totalOilAmount | wanFmt }}</span>
              <span v-else>--</span>
            </td>
            <td>
              <div v-if="totalOilAmount">{{ monthData.reduce((p, c) => p + c.oilAmountResult, 0) / totalOilAmount | percentFmt }})</div>
              <div :class="{ percent: totalOilAmount }">({{ +monthData.reduce((p, c) => p + c.oilAmountResult, 0).toFixed(2) | wanFmt }})</div>
            </td>
          </tr>
        </template>
        <template v-else>
          <tr>
            <td :colspan="13" class="no-data">暂无数据</td>
          </tr>
        </template>
      </table>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { listMonthTask } from '../services'
export default {
  name: 'MonthTask',
  filters: {
    percentFmt (val) {
      return (val * 100).toFixed(2) + '%'
    },
    wanFmt (val) {
      if (val) {
        let numberStr = (+val / 10000).toFixed(2)
        if (numberStr.endsWith('.00')) {
          numberStr = numberStr.substring(0, numberStr.length - 3)
        }
        return numberStr + '万'
      } else {
        return val
      }
    }
  },
  data () {
    return {
      curMonth: moment().format('YYYY-MM'),
      loading: false,
      monthData: []
    }
  },
  computed: {
    monthNow () {
      return moment().format('YYYY-MM')
    },
    isEnd () {
      return this.curMonth === moment().add(1, 'month').format('YYYY-MM')
    },
    showMonthStr () {
      return moment(this.curMonth + '-01', 'YYYY-MM-DD').format('M月')
    },
    totalEpcActive () {
      return this.monthData.reduce((p, c) => p + c.epcActive, 0)
    },
    totalBuyerCount () {
      return this.monthData.reduce((p, c) => p + c.buyerCount, 0)
    },
    totalOrderCount () {
      return this.monthData.reduce((p, c) => p + c.orderCount, 0)
    },
    totalFastAmount () {
      return this.monthData.reduce((p, c) => p + c.fastAmount, 0)
    },
    totalBatchAmount () {
      return this.monthData.reduce((p, c) => p + c.batchAmount, 0)
    },
    totalOilAmount () {
      return this.monthData.reduce((p, c) => p + c.oilAmount, 0)
    }
  },
  watch: {
    area () {
      this.loadMonthTasks(this.curMonth)
    }
  },
  beforeMount () {
    this.setShowMonth(this.monthNow)
  },
  methods: {
    goPreMonth () {
      const preMonth = moment(this.curMonth + '-01', 'YYYY-MM-DD').add(-1, 'month').format('YYYY-MM')
      this.setShowMonth(preMonth)
    },
    goNextMonth () {
      const nextMonth = moment(this.curMonth + '-01', 'YYYY-MM-DD').add(1, 'month').format('YYYY-MM')
      this.setShowMonth(nextMonth)
    },
    setShowMonth (month) {
      this.curMonth = month
      this.loadMonthTasks(month)
      this.$emit('changeMonth', month)
    },
    loadMonthTasks (month) {
      this.loading = true
      listMonthTask(month, this.area).then(monthData => {
        this.monthData = monthData
      }).finally(() => {
        this.loading = false
      })
    },
    configMonthTask () {
      // 配置某月数据
      this.modal('SetMonthTaskModal', this.monthData).promise.then((resp) => {
        if (resp) {
          this.loadMonthTasks(this.curMonth)
        }
      })
    }
  }
}
</script>
